import React, {useState} from 'react';
import {Grid, TextField, Link, InputAdornment, Tooltip} from '@material-ui/core';
import {Types} from "../index";
import API from "@beardeddevops/react.api"
import moment from "moment";

const EngineerReviews = ({data, isAdmin}) => {
	const [tableData, setTableData] = useState(data);
	const [key, setKey] = useState(Math.random);

	// Function to handle when a text field is blurred
	const handleBlur = async (event, row, columnKey) => {
		if (!event.target.value) {
			event.target.value = 0;
		}
		if (event.target.value == row[columnKey]) {
			return;
		}
		const updatedTableData = [...tableData];
		const foundItemIndex = updatedTableData.findIndex((item) => item.pkey === row.pkey);

		updatedTableData[foundItemIndex][columnKey] = event.target.value;

		const total = (parseInt(row.google_count) + parseInt(row.yelp_count) + parseInt(row.facebook_count) + parseInt(row.bb_count));
		row.total_count = total;
		updatedTableData[foundItemIndex]['total_count'] = total;

		setTableData(updatedTableData);
		setKey(Math.random());

		let engineerReviewsModel = new API.BuildClass(Types.Engineers_Reviews._name, API.RequestType.UPDATE);
		engineerReviewsModel.object = row;
		await engineerReviewsModel.submit(null, 'POST', true);
	};

	// Group data by region_name and sub_header for feedback_type === '1'
	const groupData = (data) => {
		const grouped = {};
		let _total = 0;

		data.forEach((row) => {
			_total += row.total_count ?? 0;
			const region = row.region_name || 'Unknown Region';

			// Initialize region group if not present
			if (!grouped[region]) {
				grouped[region] = [];
			}

			grouped[region].push(row);
		});

		return {groupedData: grouped, total: _total};
	};

	// Render column headers
	const renderHeaders = () => (
		<Grid container item spacing={2}>
			<Grid item xs={2}><strong>Engineer</strong></Grid>
			<Grid item xs={2}><strong>Google Reviews</strong></Grid>
			<Grid item xs={2}><strong>Yelp Reviews</strong></Grid>
			<Grid item xs={2}><strong>FB Reviews</strong></Grid>
			<Grid item xs={2}><strong>BB Reviews</strong></Grid>
			<Grid item xs={2}><strong>Total for Week</strong></Grid>
		</Grid>
	);

	const {groupedData, total} = groupData(tableData);

	const rowStyle = {
		border: '1px solid #ccc', // Full border around each row
		boxSizing: 'border-box', // Ensures borders are included in the element's total width and height
	};

	const tableStyle = {
		marginTop: '20px', // Optional margin for spacing
	};

	const headerStyle = {
		...rowStyle,
		backgroundColor: '#f0f0f0', // Optional: highlight the header row
		fontWeight: 'bold', // Optional: make headers bold
	};

	return (
		<div style={tableStyle} key={key}>
			<Grid container spacing={0}> {/* Removed spacing between grid items */}
				{/* Render column headers at the very top */}
				<Grid item xs={12} style={headerStyle}>
					{renderHeaders()}
				</Grid>

				{Object.keys(groupedData).map((region, regionIndex) => (
					<React.Fragment key={regionIndex}>
						{/* Region Header */}
						<Grid item xs={12} style={rowStyle}>
							<strong>{region}</strong>
						</Grid>

						<React.Fragment key={regionIndex}>
							{/* Rows for the group */}
							{groupedData[region].map((row, rowIndex) => (
								<Grid container item spacing={0} key={rowIndex} style={rowStyle}>
									<Grid item xs={2} style={rowStyle}>
										<TextField
											defaultValue={row.engineer_name}
											disabled={true}
											fullWidth
											variant="standard" // Removes underline
											InputProps={{
												disableUnderline: true,
											}}
										/>
									</Grid>
									<Grid item xs={2} style={rowStyle}>
										<TextField
											defaultValue={row.google_count}
											disabled={false}
											onChange={(e) => {
												const inputValue = e.target.value;

												// Only allow digits (0-9)
												if (!/^\d*$/.test(inputValue)) {
													e.target.value = inputValue.replace(/\D/g, ''); // Replace non-digits with an empty string
												}
											}}
											fullWidth
											onBlur={async (e) => await handleBlur(e, row, 'google_count')}
											variant="standard" // Removes underline
											InputProps={{
												disableUnderline: true,
											}}
										/>
									</Grid>
									<Grid item xs={2} style={rowStyle}>
										<TextField
											defaultValue={row.yelp_count}
											disabled={false}
											onChange={(e) => {
												const inputValue = e.target.value;

												// Only allow digits (0-9)
												if (!/^\d*$/.test(inputValue)) {
													e.target.value = inputValue.replace(/\D/g, ''); // Replace non-digits with an empty string
												}
											}}
											fullWidth
											onBlur={async (e) => await handleBlur(e, row, 'yelp_count')}
											variant="standard" // Removes underline
											InputProps={{
												disableUnderline: true,
											}}
										/>
									</Grid>
									<Grid item xs={2} style={rowStyle}>
										<TextField
											defaultValue={row.facebook_count}
											disabled={false}
											onChange={(e) => {
												const inputValue = e.target.value;

												// Only allow digits (0-9)
												if (!/^\d*$/.test(inputValue)) {
													e.target.value = inputValue.replace(/\D/g, ''); // Replace non-digits with an empty string
												}
											}}
											fullWidth
											onBlur={async (e) => await handleBlur(e, row, 'facebook_count')}
											variant="standard" // Removes underline
											InputProps={{
												disableUnderline: true,
											}}
										/>
									</Grid>
									<Grid item xs={2} style={rowStyle}>
										<TextField
											defaultValue={row.bb_count}
											disabled={false}
											onChange={(e) => {
												const inputValue = e.target.value;

												// Only allow digits (0-9)
												if (!/^\d*$/.test(inputValue)) {
													e.target.value = inputValue.replace(/\D/g, ''); // Replace non-digits with an empty string
												}
											}}
											fullWidth
											onBlur={async (e) => await handleBlur(e, row, 'bb_count')}
											variant="standard" // Removes underline
											InputProps={{
												disableUnderline: true,
											}}
										/>
									</Grid>
									<Grid item xs={2} style={rowStyle}>
										<TextField
											defaultValue={row.total_count}
											disabled={true}
											fullWidth
											variant="standard" // Removes underline
											InputProps={{
												disableUnderline: true,
											}}
										/>
									</Grid>
								</Grid>
							))}

							{/* Add an empty row for spacing between groups */}
							<Grid item xs={12}>&nbsp;</Grid>
						</React.Fragment>

					</React.Fragment>
				))}

				<Grid container item spacing={0} style={rowStyle}>
					<Grid item xs={2} style={rowStyle}>

					</Grid>
					<Grid item xs={2} style={rowStyle}>

					</Grid>
					<Grid item xs={2} style={rowStyle}>

					</Grid>
					<Grid item xs={2} style={rowStyle}>

					</Grid>
					<Grid item xs={2} style={rowStyle}>
						<TextField
							defaultValue={'TOTAL SUM'}
							disabled={true}
							fullWidth
							variant="standard" // Removes underline
							InputProps={{
								disableUnderline: true,
							}}
						/>
					</Grid>
					<Grid item xs={2} style={rowStyle}>
						<TextField
							defaultValue={total}
							disabled={true}
							fullWidth
							variant="standard" // Removes underline
							InputProps={{
								disableUnderline: true,
							}}
						/>
					</Grid>
				</Grid>

			</Grid>
		</div>
	);

};

export default EngineerReviews;